import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RECOVERY_REASONS = ['new', 'lost', 'uninstalled'];
const LostDeviceTile = ({
  openTwoFactorRecovery
}) => {
  const divider = /*#__PURE__*/_jsx(View, {
    paddingInline: "300",
    as: "div",
    children: "|"
  });
  return /*#__PURE__*/_jsxs(UITile, {
    compact: true,
    children: [/*#__PURE__*/_jsxs(UITileSection, {
      children: [/*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `reAuth.recovery.hsAuthenticatior.title`
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `reAuth.recovery.hsAuthenticatior.body`
      })]
    }), /*#__PURE__*/_jsx(UITileSection, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        direction: "row",
        children: RECOVERY_REASONS.map((reason, key) => {
          return /*#__PURE__*/_jsxs(Flex, {
            display: "inline-flex",
            children: [key !== 0 && divider, /*#__PURE__*/_jsx(UIButton, {
              use: "link",
              onClick: openTwoFactorRecovery,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `reAuth.recovery.hsAuthenticatior.${reason}`
              })
            })]
          }, key);
        })
      })
    })]
  });
};
export default LostDeviceTile;